import { useContext, useEffect, useMemo } from 'react';
import { AuthContext } from './AuthProvider';
import { useNavigate } from 'react-router';
import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  createTheme,
  ThemeProvider,
  CssBaseline,
} from '@mui/material';
import readingViewTheme from '../../../ReadingView/readerTheme';

export const LoginCallback = () => {
  const { actions, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  // Check if user was originally from ReadingView
  const contextInfo = useMemo(() => {
    const originalUrl =
      sessionStorage.getItem('original-url-before-redirect') ?? '/';
    const isFromReadingView = originalUrl.startsWith('/lue/');

    return {
      isFromReadingView,
      originalUrl,
    };
  }, []);

  useEffect(() => {
    const handleAuth = async () => {
      if (!loading && actions) {
        await actions.handleAuthentication();
        await actions.getUserInfoWithoutCache();
        navigate(contextInfo.originalUrl);
      }
    };

    handleAuth();
  }, [actions, navigate, loading, contextInfo.originalUrl]);

  // If user was from ReadingView, render with ReadingView theme
  if (contextInfo.isFromReadingView) {
    const customTheme = createTheme(readingViewTheme);

    return (
      <ThemeProvider theme={customTheme} noSsr>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'background.default',
          }}
        >
          <Stack
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
            spacing={2}
          >
            <CircularProgress variant='indeterminate' />
            <Typography
              component='h1'
              variant='h5'
              sx={{ fontWeight: 600, textAlign: 'center' }}
            >
              Ladataan lukuympäristöä...
            </Typography>
            <Typography
              variant='body2'
              sx={{
                color: 'text.secondary',
                textAlign: 'center',
                maxWidth: '300px',
              }}
            >
              Autentikoidaan käyttäjää ja varmistetaan käyttöoikeudet...
            </Typography>
          </Stack>
        </Box>
      </ThemeProvider>
    );
  }

  // Default main site loading
  return (
    <Box
      sx={{
        height: '800px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
        spacing={2}
      >
        <CircularProgress variant='indeterminate' />
        <Typography
          component='h1'
          variant='h5'
          sx={{ fontWeight: 600, textAlign: 'center' }}
        >
          Viimeistellään kirjautumista...
        </Typography>
      </Stack>
    </Box>
  );
};
